import React from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Container,
    Col,
    Row,
    Card,
    CardTitle,
    CardBody,
    Alert
} from 'reactstrap';
import {
    Redirect
} from 'react-router-dom';
import { connect } from 'react-redux';
import { AUTH_USER_KEY } from '../../constants';
import { jwtDecode } from '../../utils';
import { doEmailVerification,doRefreshToken } from '../../actions/authAction';
import queryString from 'query-string';
class PageEmailVerification extends React.Component{
    constructor(props){
        super(props);
        const params = queryString.parse(props.location.search);
        let userRaw =  false;
        const userPayloads = localStorage.getItem(AUTH_USER_KEY);
        if(props.isLogged && userPayloads){
            userRaw = JSON.parse(jwtDecode(userPayloads));
        }
        this.state={
            email: params.email,
            token: props.match.params.token,
            sameAccount :  (props.isLogged===true && userRaw.email === params.email),
            timer:5,
            redirectTo:'/',
            taskCount:0,
            taskCompleted:0,
            error: null,
            isLoading: false
        };
    }

    componentDidMount(){
        let taskCount = 1, taskCompleted = 0;
        if(this.state.sameAccount){
            taskCount++;
        }
        this.setState({ taskCount, taskCompleted, isLoading:true }, ()=>{
            const {email,token}=this.state;
            this.props.doVerify({email,token})

        })
    }

    setTimer(){
        setInterval(this.timer.bind(this),1000);
    }

    componentWillReceiveProps(nextProps){
        if(!nextProps.verification.isSubmit&&this.props.verification.isSubmit !== nextProps.verification.isSubmit && this.state.isLoading===true){
            if(nextProps.verification.status_code===200){
                let { taskCompleted } = this.state;
                taskCompleted++;
                if(this.state.sameAccount){
                    this.props.doRefreshToken();
                }
                this.setState({taskCompleted, isLoading: !(taskCompleted === this.state.taskCount)},()=>{
                    if(!this.state.isLoading){
                        this.setTimer();
                    }
                });
            }
            else{
                this.setState({ isLoading:false, error:{...nextProps.verification.error }}, this.setTimer.bind(this))
            }
        }
        if(!nextProps.refreshTkn.isSubmit&& nextProps.refreshTkn.isSubmit !== this.props.refreshTkn.isSubmit && this.state.isLoading===true){
            if(nextProps.refreshTkn.status_code===200){
                let { taskCompleted } = this.state;
                taskCompleted++;
                this.setState({taskCompleted, isLoading: !(taskCompleted ===this.state.taskCount)}, this.setTimer.bind(this));
            }
            else{
                // If refresh token error just let them show success message from verify email.
                this.setState({ isLoading:false, error:null, taskCompleted:this.state.taskCompleted+1 }, this.setTimer.bind(this))
            }
        }
    }

    timer(){
        if(this.state.timer>0)
            this.setState({timer:--this.state.timer});
    }

    renderInfo(){
        if(this.state.isLoading)
            return (
                <Alert className="no-border-radius" color="info">
                    <h4 className="alert-heading">Please Wait!</h4>
                    <strong>Heads up!</strong> Processing...
                </Alert>
            );
        else{
            if(this.state.taskCount === this.state.taskCompleted){
                return (
                    <Alert className="no-border-radius" color="success">
                        <h4 className="alert-heading">Well done!</h4>
                        <p>{`${this.props.verification.message}. Happy Shopping.`}</p>
                        <hr/>
                        <p className="mb-0">
                            {`This page will be auto redirect to homepage after (${this.state.timer}) seconds.`}
                        </p>
                    </Alert>
                )
            }
            if(this.state.error!==null){
                return (
                    <Alert className="no-border-radius" color="danger">
                        <strong>Oh snap!</strong>
                        <p>
                            {this.state.error.message}
                        </p>
                        <hr/>
                        <p className="mb-0">
                         {`This page will be auto redirect to homepage after (${this.state.timer}) seconds.`}
                        </p>
                    </Alert>
                )
            }
        }
        return '';
    }
    render(){
        if(this.state.timer===0)
            return <Redirect to={this.state.redirectTo}/>
        return (
            <Container className="main-container page-container reset-password" id="email-verification-page">
                <Row>
                    <Col xs={12} className="reset-password-col">
                        <Card className="no-border-radius">
                            <CardBody>
                                <CardTitle className="text-center">Email Verification</CardTitle>
                            </CardBody>
                            <CardBody>
                                {this.renderInfo()}
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        )
    }
}
const mapStateToProps=(state)=>{
    return{
        verification:state.dataAuth.userVerification,
        refreshTkn : state.dataAuth.refreshTkn,
        isLogged : state.dataAuth.isLogged
    }
}
const mapDispatchToProps=(dispatch)=>{
	return {
		doVerify: payload => dispatch(doEmailVerification(payload)),
		doRefreshToken: () => dispatch(doRefreshToken())
	}
}
export default connect(mapStateToProps,mapDispatchToProps)(PageEmailVerification);